export const getPageNum = (moduleOrPageElement) => {
    return parseInt(moduleOrPageElement.dataset.page, 10);
};
export const getEmptyModuleCoordinates = (validModules, size, width) => {
    const validModule = validModules.find((moduleInfo) => moduleInfo.pageWidth === width && moduleInfo.pageSize === size);
    if (validModule) {
        return { x: validModule.x, y: validModule.y };
    }
    return null;
};
export const getPageNumFromPageId = (pageId) => {
    return parseInt(pageId.replace('pdf-page-', '').split('-')[0], 10);
};
export const getModuleSize = (moduleElement) => {
    return parseInt(moduleElement.dataset.size, 10);
};
export const getCustomizableFieldValues = (fields) => {
    return Object.keys(fields).reduce((acc, fieldName) => {
        acc[fieldName] = fields[fieldName].value;
        return acc;
    }, {});
};
export const convertModulesToSaveState = (modules) => {
    return modules.map((page) => {
        return page.map((module) => {
            return {
                ...module,
                // Ignore module field metadata and reduce customizable fields to their values
                customizable_fields: getCustomizableFieldValues(module.customizable_fields),
            };
        });
    });
};
export const getFiltersFromAllowedModuleSizes = (allowedModuleSizes, allModuleSizes) => {
    const all = allowedModuleSizes.length === allModuleSizes.length;
    let filters = {
        all,
    };
    allModuleSizes.forEach((moduleSize) => {
        filters = {
            ...filters,
            [moduleSize]: false,
        };
    });
    if (!all) {
        allowedModuleSizes.forEach((moduleSize) => {
            filters[moduleSize] = true;
        });
    }
    return filters;
};
